import de from './de-DE.json'
import en from './en-GB.json'

export default {'de-DE': de, 'en-GB': en}



// WEBPACK FOOTER //
// ./src/lang/msg/index.js